export default __webpack_public_path__ + "static/media/NunitoSans-Regular.d6d0557e.woff";